import {
  StateUpdateChatEventNode,
  RequestStateUpdateChatEventNode,
  ClientChatEvent,
} from './messages/MessageTypes';

interface ChatSystemState {
  error_message?: string;
}

function getLatestStateUpdateEvent(events: Array<ClientChatEvent>): StateUpdateChatEventNode | undefined {
  return events.findLast(
    (event): event is StateUpdateChatEventNode => event.__typename === 'StateUpdateChatEventNode'
  );
}

function getLatestRequestStateUpdateEvent(
  events: Array<ClientChatEvent>
): RequestStateUpdateChatEventNode | undefined {
  return events.findLast(
    (event): event is RequestStateUpdateChatEventNode =>
      event.__typename === 'RequestStateUpdateChatEventNode'
  );
}

export function getLatestApplicationState(events: Array<ClientChatEvent>): object | null {
  const stateUpdateEvent = getLatestStateUpdateEvent(events);
  return stateUpdateEvent?.newState.chat_state.application_state ?? null;
}

export function getLatestSystemState(events: Array<ClientChatEvent>): ChatSystemState | null {
  const stateUpdateEvent = getLatestStateUpdateEvent(events);
  return stateUpdateEvent?.newState.chat_state.system_state ?? null;
}

/**
 * Get the publicDataEnabled setting from the last RequestStateUpdateChatEventNode.
 * Falls back to false if not found.
 */
export function getLatestPublicDataEnabled(events: Array<ClientChatEvent>): boolean {
  const requestStateUpdateEvent = getLatestRequestStateUpdateEvent(events);
  return requestStateUpdateEvent?.publicDataEnabled ?? false;
}
